import React, { useEffect, useState, useContext } from "react";
import { Form } from "react-bootstrap";
import toast from "react-hot-toast";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar.jsx";
import blogFetch from "../../axios/config";
import { IAddUser } from "./UserGroupsInterfaces";
import { getCookie } from "../../section/cookie";
import Context from "../../context/Context";
import { Context as AuthContext } from "../../context/AuthContext";
import language from "../../nls/language.json";

export default function UpdateUser() {
  const [user, setUser] = useState<IAddUser>({
    User_Active: true,
    user_CompanyId: 1,
    user_Password: "",
    User_Email: " ",
    user_UserName: "",
    User_Matricula: 0,
    User_SAPMatricula: 0,
    user_Sector: null
  });
  const [oldPassword, setOldPassword] = useState<string>("");
  const [oldName, setOldName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const { selectedCountry } = useContext(Context);
  const { handleLogout } = useContext(AuthContext);
  const textos = (language as Record<string, any>)[selectedCountry.name].Permissoes.config;

  const senhasDiferentes = confirmPassword !== "" && password !== confirmPassword;

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    let id = getCookie("userId");
    try {
      let response = await blogFetch.get(`/user/${id}`);
      let data = response.data;
      setUser({
        ...user,
        user_CompanyId: data.user_CompanyId,
        User_Email: data.user_Email,
        user_UserName: data.user_UserName,
        User_Matricula: data.user_Matricula,
        User_SAPMatricula: data.user_SAPMatricula,
      });
      setOldName(data.user_UserName);
    } catch (error) {
      console.error(error);
      toast.error("Erro ao carregar os dados do usuário.");
    }
  };

  const updateUser = async () => {
    if (!oldPassword || !password || !confirmPassword) {
      toast.error("Preencha a senha atual, a nova senha e a confirmação.");
      return;
    }
    if (password !== confirmPassword) {
      toast.error(textos.senhasIncorretas);
      return;
    }

    setLoading(true);

    let validUser = {
      USR_userName: oldName,
      USR_password: oldPassword,
    };
    try {
      await blogFetch.post("token", validUser);
    } catch (error) {
      toast.error("Senha atual inválida.");
      setLoading(false);
      return;
    }

    let id = getCookie("userId");
    const updateUser: IAddUser = {
      user_CompanyId: user.user_CompanyId,
      user_Password: password,
      user_UserName: user.user_UserName,
      User_Email: user.User_Email,
      User_Matricula: user.User_Matricula,
      User_SAPMatricula: user.User_SAPMatricula,
      User_Active: user.User_Active,
      user_Sector: user.user_Sector
    };
    try {
      await blogFetch.put(`/user/${id}`, updateUser);
      toast.success("Senha alterada com sucesso. Faça login novamente.");
      setTimeout(() => handleLogout(), 1500);
    } catch (error: any) {
      console.error(error);
      const apiData = error.response?.data;
      const msg = apiData?.message || (typeof apiData === "string" ? apiData : null);
      toast.error(msg || "Erro ao atualizar o usuário.");
      setLoading(false);
    }
  };

  return (
    <div className="d-flex app_">
      <Sidebar />
      <Navbar />
      <div className="flex-grow-1">
        <div className="container-fluid mt-3 app_body d-flex flex-column align-items-center px-2 px-sm-3">
          <div style={{ width: "100%", maxWidth: 700 }}>
            <h4 className="fw-bold text-primary mb-3 text-center text-md-start">
              {textos.title}
            </h4>

            <Form onSubmit={(e) => { e.preventDefault(); updateUser(); }}>
              {/* Dados do usuário */}
              <div className="card shadow-sm mb-3">
                <div className="card-body">
                  <h6 className="fw-bold text-dark mb-3">Dados do Usuário</h6>
                  <div className="row g-2 g-md-3">
                    <div className="col-12 col-md-4">
                      <label className="form-label small fw-bold text-dark mb-1">Login</label>
                      <input value={user.user_UserName} className="form-control" readOnly disabled />
                    </div>
                    <div className="col-6 col-md-4">
                      <label className="form-label small fw-bold text-dark mb-1">SAP Login</label>
                      <input
                        value={!user.User_SAPMatricula ? "" : user.User_SAPMatricula}
                        className="form-control"
                        readOnly
                        disabled
                      />
                    </div>
                    <div className="col-6 col-md-4">
                      <label className="form-label small fw-bold text-dark mb-1">Matrícula</label>
                      <input
                        value={!user.User_Matricula ? "" : user.User_Matricula}
                        className="form-control"
                        readOnly
                        disabled
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label small fw-bold text-dark mb-1">Email</label>
                      <Form.Control
                        type="text"
                        value={user.User_Email}
                        onChange={(e) => setUser({ ...user, User_Email: e.target.value })}
                        disabled={loading}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Senha */}
              <div className="card shadow-sm mb-3">
                <div className="card-body">
                  <h6 className="fw-bold text-dark mb-3">Alterar Senha</h6>
                  <Form.Group className="mb-3">
                    <Form.Label className="small fw-bold text-dark mb-1">Senha Atual</Form.Label>
                    <Form.Control
                      type="password"
                      size="lg"
                      value={oldPassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                      autoComplete="current-password"
                      disabled={loading}
                    />
                  </Form.Group>
                  <div className="row g-2 g-md-3">
                    <div className="col-12 col-md-6">
                      <Form.Label className="small fw-bold text-dark mb-1">Nova Senha</Form.Label>
                      <Form.Control
                        type="password"
                        size="lg"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="new-password"
                        isInvalid={senhasDiferentes}
                        disabled={loading}
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <Form.Label className="small fw-bold text-dark mb-1">Confirmar Senha</Form.Label>
                      <Form.Control
                        type="password"
                        size="lg"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        autoComplete="new-password"
                        isInvalid={senhasDiferentes}
                        disabled={loading}
                      />
                    </div>
                  </div>
                  {senhasDiferentes && (
                    <div className="text-danger fw-semibold mt-2">{textos.senhasIncorretas}</div>
                  )}
                  <small className="text-muted d-block mt-2">
                    Após atualizar, você será desconectado e precisará entrar novamente com a nova senha.
                  </small>
                </div>
              </div>

              <button
                type="submit"
                className="btn btn-primary btn-lg w-100 py-3 mb-3"
                style={{ fontSize: "1.1rem" }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" />
                    Atualizando...
                  </>
                ) : (
                  textos.btnAtualizar
                )}
              </button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
